import React from 'react';
import PropTypes from 'prop-types';
import LocalizedLink from 'helpers/LocalizeLink';

function TryFreeWidget(props) {
    if (!props?.title && !props?.additional_text_1 && !props?.additional_text_2 && !props?.button_text && !props?.path) return null;

    return (
        <div className={"widget widget-tryfree" + (props?.dark ? " bg-dark" : "")}>
            <div className={'container-xl row mx-auto ' + props?.className}>
                <div data-test-id="tryfree-wr-d" className="desktop col-md-12 d-none d-md-block">
                    <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="1171"
                        height="292"
                        viewBox="0 0 1171 292">
                        <defs>
                            <clipPath id="a">
                                <rect className="a" fill="none" width="1171" height="292" transform="translate(1191)" />
                            </clipPath>
                            <linearGradient id="b" x1=" 70%" y1="0%" x2="125%" y2="16%" gradientUnits="objectBoundingBox">
                                <stop offset="0" stopColor="#465168" />
                                <stop offset="1" stopColor="#00abaa" />
                            </linearGradient>
                            <linearGradient id="c" x1=" 70%" y1="0%" x2="125%" y2="16%" gradientUnits="objectBoundingBox">
                                <stop offset="0" stopColor="#ec5f55" />
                                <stop offset="1" stopColor="#00abaa" />
                            </linearGradient>
                            <linearGradient id="d" x1="0.555" y1="0.466" x2="0.851" y2="1.953"
                                gradientUnits="objectBoundingBox">
                                <stop offset="0" stopColor="#ec5f55" />
                                <stop offset="1" stopColor="#00abaa" />
                            </linearGradient>
                        </defs>
                        <g className="b" clipPath="url(#a)" transform="translate(-1191)">
                            <path className="c" fill="url(#b)"
                                d="M1009.831,184.2H-65.057v292a0,0,0,0,0,0,0H1010.23l95.713-145.7Z"
                                transform="translate(1256.057 -184.199)" />
                            <path className="d" fill="url(#c)"
                                d="M1009.831,184.2H-65.057v292a0,0,0,0,0,0,0H1010.23l95.713-145.7Z"
                                transform="translate(65.057 -184.199)" />
                            <path className="e" fill="#fff" opacity="0.7"
                                d="M876.813,184.2h-79l96.112,146.3L798.212,476.2h79l95.713-145.7Z"
                                transform="translate(1290.057 -184.199)" />
                            <path className="f" fill="#fff" opacity="0.5"
                                d="M999.831,184.2h-79l96.112,146.3L921.23,476.2h79l95.713-145.7Z"
                                transform="translate(1256.057 -184.199)" />
                            <text className="g" style={{
                                fontSize: '45px',
                                fontFamily: 'Gordita-BoldItalic, Gordita',
                                fontWeight: 700,
                                fontStyle: 'italic'
                            }} fill="#fff" transform="translate(1291 76.396)">
                                {props?.title ? <tspan x="0" y="0" data-test-id="tryfree-title-d">{props?.title}</tspan> : null}
                                {
                                    props?.additional_text_1 || props?.additional_text_2 ?
                                    <tspan className="h" style={{ fontSize: '30px' }}>
                                        {props?.additional_text_1 ? <tspan x="0" y="49" data-test-id="tryfree-text1-d">{props?.additional_text_1}</tspan> : null}
                                        {props?.additional_text_2 ? <tspan x="0" y="82" data-test-id="tryfree-text2-d">{props?.additional_text_2}</tspan> : null}
                                    </tspan>
                                    : null
                                }
                            </text>
                        </g>
                        <foreignObject x="92" y="201" width="250" height="60" className="q">
                            {
                                props?.button_text && props?.path ?
                                    <LocalizedLink dti="tryfree-btn-d" className="btn-cta z text-white text-semibold text-medium d-flex justify-content-center align-items-center w-100 p-12" to={props.path ? props.path : null}>
                                        {props.button_text}
                                    </LocalizedLink>
                                    : null
                            }
                        </foreignObject>
                    </svg>
                </div>
                <div data-test-id="tryfree-wr-m" className="mobile col-12 d-block d-md-none text-center px-2 py-4">
                    {props?.title ? <p data-test-id="tryfree-title-m" className="cta-title text-xs-big text-white text-bold text-italic mb-3 mb-sm-4">{props.title} <span></span></p> : null}
                    {props?.additional_text_1 ? <p data-test-id="tryfree-text1-m" className="text-white text-xs-medium text-sm-big text-semibold text-italic mb-3 mb-sm-4">{props.additional_text_1}</p> : null}
                    {props?.additional_text_2 ? <p data-test-id="trydfree-text2-m" className="text-white text-xs-medium text-sm-big text-semibold text-italic mb-4 mb-sm-5">{props.additional_text_2}</p> : null}
                    {
                        props?.button_text && props?.path ?
                            <LocalizedLink dti="tryfree-btn-m" className="btn-cta large text-white text-semibold px-12 w-100 d-flex justify-content-center align-items-center mx-auto" to={props.path ? props.path : null}>
                                {props.button_text}
                            </LocalizedLink> : null
                    }
                </div>
            </div>
        </div>
    )
}

TryFreeWidget.propTypes = {
    title: PropTypes.string,
    additional_text_1: PropTypes.string,
    additional_text_2: PropTypes.string,
    button_text: PropTypes.string,
    path: PropTypes.string,
}

export default TryFreeWidget;
